export default __webpack_public_path__ + "img/pin_icons/eye_wash_b.svg";